module.exports = __webpack_public_path__ + "img/soundicon.3f76ad16.svg";